import React, { useContext } from 'react';
import GridItemBuyArea from './GridItemBuyArea';
import { SettingsContext } from './Context';

const GridItem = props => {
    const settings = useContext(SettingsContext);

    const inventory = props.data.price?.commerceData?.inventory ? props.data.price.commerceData.inventory : 0;

    var displayLowStockVerbiage = inventory < 51  && props.data.price.commerceData?.status == "Out of Production";

    const callAddToCart = () => {
        const multiple = props.data.price.commerceData?.multiple ? props.data.price.commerceData.multiple : 1;
        props.addToCart(props.data.skuNumber, props.data.name, props.data.skuId, props.data.originalSkuNumber, props.data.modelId, multiple, false, props.data.category, props.data.priceUnformatted);
    };

    return (
        <div className="variantPickerComponent-productItem">
            {
                props.data.url &&
                <a href={props.data.url}>
                    <img className="variantPickerComponent-productImage img-responsive" src={props.data.imageUrl} alt={props.data.name} />
                </a>
                ||
                <img className="variantPickerComponent-productImage img-responsive" src={props.data.imageUrl} alt={props.data.name} />
            }
            <div className="variantPickerComponent-productInner">
                {
                    props.data.url &&
                    <a href={props.data.url}>
                        <div className="variantPickerComponent-productHeader u-textSemi14">{props.data.name}</div>
                    </a>
                    || 
                    <div className="variantPickerComponent-productHeader  u-textSemi14">{props.data.name}</div>
                }

                {settings.isEDometicContext && <div className="variantPickerComponent-productArtnr u-textRegular14">{props.data.skuNumber} {props.data.legacyItemNumber && <span>({props.data.legacyItemNumber})</span>}</div>}
                <div className="variantPickerComponent-productDesc">{props.data.description}</div>
            </div>
           
            <div className="variantPickerComponent-productMeta">
                {settings.renderb2bbuyarea && props.data.price && props.data.price.commerceData && props.data.price.commerceData.givenPrice && <GridItemBuyArea addToCart={callAddToCart} price={props.data.price} buyable={props.data.price.commerceData.buyable} displayLowStockVerbiage={displayLowStockVerbiage} />}
            </div>
        </div>
    );
};

export default GridItem;